import { render, staticRenderFns } from "./Brokers.vue?vue&type=template&id=d63d814a"
import script from "./Brokers.vue?vue&type=script&lang=js"
export * from "./Brokers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports